<script>
import { Cascader } from 'element-ui';
import { projectRegions, displayRegionValue, restoreRegionValue } from '@/js/region/municipality';

export default {
  name: 'RegionCascader',
  inheritAttrs: false,
  props: {
    options: { type: Array, default: () => [] },
    value: { default: undefined },
    props: { type: Object, default: () => ({}) },
  },
  computed: {
    /** 生成展示树并保留原始路径映射。 */
    projected() { return projectRegions(this.options); },
    /** 保留统计页面通过 ref 关闭下拉框的行为。 */
    dropDownVisible: {
      get() { return this.$refs.inner && this.$refs.inner.dropDownVisible; },
      set(value) { if (this.$refs.inner) this.$refs.inner.dropDownVisible = value; },
    },
  },
  methods: {
    /** 将界面两级选择恢复为业务所用的三级路径。 */
    restore(value) {
      return restoreRegionValue(value, this.value, this.projected.paths, !!this.props.multiple, this.props.emitPath !== false);
    },
    /** 保留级联选择器公开的节点查询方法。 */
    getCheckedNodes(leafOnly) { return this.$refs.inner.getCheckedNodes(leafOnly); },
  },
  /** 转发属性、插槽及事件，只在组件边界转换区划路径。 */
  render(h) {
    return h(Cascader, {
      ref: 'inner',
      attrs: this.$attrs,
      props: {
        ...this.$attrs,
        options: this.projected.options,
        props: this.props,
        value: displayRegionValue(this.value, !!this.props.multiple, this.props.emitPath !== false),
      },
      on: {
        ...this.$listeners,
        input: value => this.$emit('input', this.restore(value)),
        change: value => this.$emit('change', this.restore(value)),
      },
      scopedSlots: this.$scopedSlots,
    }, this.$slots.default);
  },
};
</script>
